import { useEffect } from "react";

const useOnMount = (effect) => {
  useEffect(() => {
    return effect();
    // This hook intentionally mirrors useEffect(..., [])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useOnMount;
